import type { Tone } from "../../../../lib/home-mock";

// Literal class strings per tone (Tailwind only sees full class names).
// `bg` is the card background; `ink` colors icons and small accents on it.
export const TONE_BG: Record<Tone, string> = {
  yellow: "bg-tint-yellow",
  blue: "bg-tint-blue",
  green: "bg-tint-green",
  red: "bg-tint-red",
  teal: "bg-tint-teal",
  violet: "bg-tint-violet",
  orange: "bg-tint-orange",
  pink: "bg-tint-pink",
};

export const TONE_INK: Record<Tone, string> = {
  yellow: "text-ink-yellow",
  blue: "text-ink-blue",
  green: "text-ink-green",
  red: "text-ink-red",
  teal: "text-ink-teal",
  violet: "text-ink-violet",
  orange: "text-ink-orange",
  pink: "text-ink-pink",
};
